import Localization from 'lib/localization';

export default {
  /**
   *
   * @returns @TODO: feel free to add lexemes here, once they are ready
   */
  lxPagePrivacyPolicyIntroSectionTitle() {
    return Localization.get('bumblesite@privacy.hero.title');
  },
  lxPagePrivacyPolicyIntroSectionText() {
    return Localization.get('bumblesite@privacy.hero.text');
  },
  lxPagePrivacyPolicyIntroSectionRightTopTooltipText() {
    return Localization.get('bumblesite@privacy.hero.tooltip.right');
  },
};
